import React from "react";

function Loading() {
return (
    <>Loading...</>
)
}

export default Loading;